const data = {
  primaryColor: "#b71c1c",
  lightColor: true,
  title: "Dev Tools",
  category: "Tools",
  icon: "/images/app-icons/dev-tools.png",
  slogan: "Free tools that make life easier not only for programmers",
  shortDescription:
    "Multi-purpose Android and web application that contains over 18 useful tools for developers and everyday users. Contains variety tools for encrypting, hashing, encoding and hashing text, converting between units, generating random numbers and GUIDs.",
  fullDescription:
    "Dev Tools is multi-purpose Android and web application that contains over 18 useful tools for developers and everyday users. Dev Tools contains tools for generating secure passwords, generating barcodes, encoding and decoding text to and from Base 32, Base 64. Users can also escape special symbols for XML, HTML, JSON, JAVA or JavaScript, use the Random Number Generator as a dice or decision maker. There is also present unit and text converter and tools for encrypting text in various cyphers and hashing text. This application is useful all-in-one tool for developers and also for an average user looking for simple solutions to everyday problems.",
  usesCases: [
    "Generating barcode for your website, game or to save some information",
    "Encoding to Base 32, Base 64 and URL or decoding from it",
    "Escaping special symbols for your XML, HTML, JSON, JAVA or JavaScript",
    "Generating new better and sager passwords",
    "Using Random Number Generator as dice for your game or decision maker",
    "Scanning barcodes around you on your Android device",
    "Generating guids as unique identifiers",
    "Encrypting or hashing your text",
    "Converting between units",
  ],
  properties: [
    "Case Converter",
    "Text Converter",
    "Unit Converter",
    "Base32 Encoder/Decoder",
    "Base64 Encoder/Decoder",
    "URL Encoder/Decoder",
    "Text Encryptor",
    "HTML Escaper/Unescaper",
    "XML Escaper/Unescaper",
    "JSON Escaper/Unescaper",
    "JAVA Escaper/Unescaper",
    "JavaScript Escaper/Unescaper",
    "Guid Generator",
    "Hash Generator",
    "Hmac Generator",
    "Password Generator",
    "Random Number Generator",
    "Barcode Generator (Available only in Web Application)",
    "URL Parser",
    "Html Stripper",
    "Barcode Scanner (Available only in Android Application",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: null,
    requirements:
      "This application does not need any special requirements to run.",
    requiredAndroidVersion: "5.0 and up",
    versioning: {
      releasedOn: new Date(2023, 1, 27),
      currentVersion: "1.0.0",
      updatedOn: new Date(2023, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=dev.davidsimak.devtools",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: null,
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-1.png",
        description: "Main screen with selection of all available tools",
      },
      {
        title: "Unit Converter",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-2.png",
        description: "Unit converter tool",
      },
      {
        title: "Password Generator",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-3.png",
        description: "Password generator tool",
      },
      {
        title: "Case Converter",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-4.png",
        description: "Case converter tool",
      },
      {
        title: "Text Encryptor",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-5.png",
        description: "Text encryption tool",
      },
      {
        title: "Guid Generator",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-6.png",
        description: "Guid generator tool",
      },
      {
        title: "Url Parser",
        url: "/images/project-screenshots/dev-tools/dev-tools-android-7.png",
        description: "Url parser tool",
      },
    ],
  },
  frontend: {
    url: "https://dev-tools.davidsimak.dev",
    versioning: {
      releasedOn: new Date(2023, 1, 27),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [
      {
        title: "Main page",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-1.png",
        description: "Main page with selection of all available tools",
      },
      {
        title: "Unit Converter",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-2.png",
        description: "Unit converter tool",
      },
      {
        title: "Password Generator",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-3.png",
        description: "Password generator tool",
      },
      {
        title: "Case Converter",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-4.png",
        description: "Case converter tool",
      },
      {
        title: "Text Encryptor",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-5.png",
        description: "Text encryption tool",
      },
      {
        title: "Guid Generator",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-6.png",
        description: "Guid generator tool",
      },
      {
        title: "Url Parser",
        url: "/images/project-screenshots/dev-tools/dev-tools-web-7.png",
        description: "Url parser tool",
      },
    ],
  },
  backend: {
    versioning: {
      releasedOn: new Date(2023, 1, 27),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    techInformation: {
      language: "Java 17",
      framework: "Spring Boot 2.7.1",
      logging: "Log4j2",
      metrics: "Spring Boot Actuator",
      virtualization: "Docker",
      containerOS: "openjdk:17.0.2-slim",
      deployed: "k3s cluster",
      database: null,
      integrations: [],
    },
  },
};

class DevToolsProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "dev-tools",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new DevToolsProjectData();
